import {convertRowsToData} from '../utils/dataUtils'

export default function BubbleDataController (rows,config,hiddenItems) {
  
  let headers = rows[0]
  let propperHeaders = ['id','x','y','size','group']
  let data = convertRowsToData([propperHeaders,...rows.slice(1)],4)
  
  data = data.map((point)=>{
    return {
      id: point.id,
      x: +point.value.find((d)=>d.id==='x').value,
      y: +point.value.find((d)=>d.id==='y').value,
      group: point.value.find((d)=>d.id==='group').value,
      size: +point.value.find((d)=>d.id==='size').value
    }
  })

  if(hiddenItems) data = data.filter((d)=>hiddenItems.indexOf(d.group)<0)


  return data
}